"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SIZE_OPTIONS = exports.PADDING_OPTIONS = exports.ALIGNMENT_CLASSES = void 0;
var ALIGNMENT_CLASSES = {
  start: '',
  baseline: 'private-checkbox--align-baseline',
  center: 'private-checkbox--align-center',
  end: 'private-checkbox--align-end'
};
exports.ALIGNMENT_CLASSES = ALIGNMENT_CLASSES;
var PADDING_OPTIONS = {
  default: '',
  none: 'private-checkbox--flush'
};
exports.PADDING_OPTIONS = PADDING_OPTIONS;
var SIZE_OPTIONS = {
  default: '',
  sm: 'private-checkbox--small'
};
exports.SIZE_OPTIONS = SIZE_OPTIONS;